export const formatCount = (num) => {
  if (num === null || num === undefined || num === "") return "0";
  const n = Number(String(num).replace(/,/g, ""));
  if (!Number.isFinite(n)) return String(num);
  return n.toLocaleString("en-US", { maximumFractionDigits: 2 });
};

export const formatCompact = (num) => {
  const n = Number(String(num ?? 0).replace(/,/g, "")) || 0;
  const short = (v) => v.toFixed(1).replace(/\.0$/, "");
  if (Math.abs(n) >= 1000000) return `${short(n / 1000000)}M`;
  if (Math.abs(n) >= 1000) return `${short(n / 1000)}K`;
  return formatCount(n);
};

export const formatCountFit = (num, maxChars = 7) => {
  const full = formatCount(num);
  return full.length <= maxChars ? full : formatCompact(num);
};
